import styled from 'styled-components';
import { useState } from 'react';
import { TitleElement } from '../text/CohortLp/CohortLpTextElements';
import SYPrimaryButton from '../SYPrimaryButton';
import { CLOUDFRONT_STATIC, CSS_BREAKPOINTS_MIN, GUTTER_SIZE } from '../../config/constants';
import AspectRatio from '../AspectRatio';
import VideoJsPlayer from '../VideoJsPlayer';
import {
  CloseIcon, CloseIconWrapper, SYModal, SYModalContent,
} from '../modals/SYModalElements';
import makeImageUrl from '../../modules/makeImageUrl';
import { ReactComponent as PlayMediaSvg } from '../../assets/svg/media-play-button.svg';

const Container = styled.div`
  padding: ${GUTTER_SIZE * 2}px 0;

  @media ${CSS_BREAKPOINTS_MIN.sm} {
    padding: ${GUTTER_SIZE * 2.5}px 0 ${GUTTER_SIZE * 3.5}px;
  }
`;

const Content = styled.div`
  @media ${CSS_BREAKPOINTS_MIN.sm} {
    display: flex;
    flex-direction: row;
  }
`;

const VideoWrapper = styled.div`
  margin: 0 0 ${GUTTER_SIZE * 2}px;
  cursor: pointer;

  @media ${CSS_BREAKPOINTS_MIN.sm} {
    flex: 0 0 40%;
    margin: 0;
    padding-right: 5%;
  }
`;

const VideoElement = styled(AspectRatio)`
  background: url(${makeImageUrl({ url: `${CLOUDFRONT_STATIC}/img/pages/marlene-lp/marlene-video-thumbnail.jpg` })}) no-repeat center / cover;
`;

const ListWrapper = styled.div``;

const List = styled.ul`
  padding-left: ${GUTTER_SIZE}px;
  list-style: disc;
`;

const ListItem = styled.li`
  font-family: Poppins-Light, sans-serif;
  font-size: 15px;
  line-height: 26px;
  margin: 0 0 ${GUTTER_SIZE}px;

  strong {
    font-weight: 600;
  }

  @media ${CSS_BREAKPOINTS_MIN.sm} {
    font-size: 16px;
    line-height: 22px;
    margin: 0 0 ${GUTTER_SIZE * 2.5}px;
  }
`;

const CTAWrapper = styled.div`
  padding: 0 ${GUTTER_SIZE}px;
`;

const CTA = styled(SYPrimaryButton)`
  width: 100%;

  @media ${CSS_BREAKPOINTS_MIN.sm} {
    width: auto;
    min-width: 320px;
  }
`;

const PreviewVideoModal = styled(SYModal)`
  background: none;
  padding: 0;
`;

const PreviewVideoContainer = styled(SYModalContent)`
  background: none;
  padding: 0;
`;

const CloseIconContainer = styled(CloseIconWrapper)`
  position: absolute;
  top: -50px;
  right: 0;

  @media ${CSS_BREAKPOINTS_MIN.sm} {
    top: -70px
  }
`;

const PlayMediaIcon = styled.svg.attrs({ as: PlayMediaSvg })`
  position: absolute;
  left: 50%;
  top: 50%;
  width: 50px;
  height: 50px;
  margin-right: ${GUTTER_SIZE / 2}px;
  transform: translate(-50%, -50%);

  @media ${CSS_BREAKPOINTS_MIN.sm} {
    width: 60px;
    height: 60px;
  }
`;

const VIDEO_URL = 'https://d2jyzdmyoz9h0c.cloudfront.net/marlene-training-transcoded/Marlene Website Trailer.m3u8';

const MarleneTrainWithBest = ({ onCTAClick, ctaTitle = 'ENROLL NOW' }) => {
  const [showVideoModal, setShowVideoModal] = useState(false);

  const onVideoStartClick = () => {
    setShowVideoModal(true);
  };

  const onVideoEndCallback = () => {
    setShowVideoModal(false);
  };

  return (
    <Container>
      <Content>
        <VideoWrapper>
          <VideoElement ratio={1} onClick={onVideoStartClick}>
            <PlayMediaIcon />
          </VideoElement>
        </VideoWrapper>

        <ListWrapper>
          <TitleElement style={{ textAlign: 'left' }}>Train with the best</TitleElement>
          <List>
            <ListItem>
              Train with Marlene Schmitt  – every session, every week
            </ListItem>
            <ListItem>
              Deep dive into the holistic practice of Vinyasa Yoga, a complete path to Self Discovery
            </ListItem>
            <ListItem>
              Expert-guided sessions of asana (postures), pranayama (breath-work), meditation and kriya (yoga of electricity)
            </ListItem>
            <ListItem>
              Weekly Transformational Yoga Journeys with Marlene Schmitt
            </ListItem>
            <ListItem>
              Learn practical tools and techniques to address and transform all aspects of your life
            </ListItem>
            <ListItem>
              Experience deep inner awareness, transformation and growth.
            </ListItem>
          </List>

          <CTAWrapper>
            <CTA title={ctaTitle} onClick={onCTAClick} />
          </CTAWrapper>
        </ListWrapper>

        {showVideoModal && (
          <PreviewVideoModal isOpen={showVideoModal} onRequestClose={onVideoEndCallback}>
            <PreviewVideoContainer>
              <CloseIconContainer onClick={onVideoEndCallback}>
                <CloseIcon />
              </CloseIconContainer>
              <VideoJsPlayer videoUrl={VIDEO_URL} onVideoEnd={onVideoEndCallback} />
            </PreviewVideoContainer>
          </PreviewVideoModal>
        )}
      </Content>
    </Container>
  );
};

export default MarleneTrainWithBest;
